import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=6f8ff1f9&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ff1f9",
  null
  
)

export default component.exports